import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { Loader } from 'react-feather';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Card } from '../../../components/Card';
import { Cell, List, Row } from '../../../components/List';
import { getPropByName } from '../../../utils/props';
import { IsOpen } from '../../../components/Icon';
import { selectWork } from '../../Api/selectors';
import { selectPermissions } from '../../Api/selectors';
import { fetchInvoice } from '../../Invoices/actions';
import { REQUEST_INVOICE } from '../../Invoices/constants';
import { selectInvoiceById } from '../../Invoices/selectors';
import { getDate } from '../helpers';
import { Link } from 'react-router-dom';
import { InvoiceStatus } from '../../Invoices/components/InvoiceStatus';
import { WithUser } from './../../Users/components/WithUser';
import { REQUEST_USER } from '../../Users/constants';
import { selectUser } from '../../Users/selectors';
import cn from 'classnames';
import styles from './CardOutgoingInvoice.module.css';

import { HBox } from '../../../components/Box';

const Container = styled.div`
  font-size: 14px;

  .cell:first-child {
    text-transform: capitalize;
  }

  .status-label {
    width: fit-content;
  }
`;

const STATE = {
  invoice: null,
  isOpen: true,
};

/* eslint-disable react/prefer-stateless-function */
class VehicleOutgoingInvoiceCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    this.props.vehicle?.outgoing_invoice &&
      this.props.fetch(this.props.vehicle?.outgoing_invoice, res => {
        if (res.id) {
          this.setState({ invoice: res });
        }
      });
  }

  componentDidUpdate(prevProps, prevState) {
    this.props.vehicle?.outgoing_invoice &&
      !this.state.invoice &&
      this.props.fetch(this.props.vehicle?.outgoing_invoice, res => {
        if (res.id) {
          this.setState({ invoice: res });
        }
      });
  }

  get extraTotalEmount() {
    let total = 0;
    this.state.invoice?.invoiceSubjects.map(subject =>
      ['cost', 'product'].includes(subject.type) ? (total += subject.price) : (total = total),
    );

    return total;
  }

  render() {
    const vehicle = this.props.vehicle;
    const { invoice } = this.state;
    const outgoingCompanyLabel = `${getPropByName(invoice?.outgoingCompany, 'name') ?? ''} ${getPropByName(
      invoice?.outgoingCompany,
      'surname',
    ) ?? ''}`;
    let typesArr = [
      'client',
      'seller',
      'total_amount',
      'extra_total_amount',
      'outgoing_invoice_generated_date',
      'outgoing_invoice_finalized_date',
      'bpm_guarantee_sum',
      'paymentStatus',
    ];

    if (this.props.work) return <Loader small="true" />;
    if (this.props.vehicle?.outgoing_invoice && !invoice) return <Loader small="true" />;

    return (
      <Card className={cn('vehicle-info-card info-card data', styles.card)}>
        <Container>
          <HBox vCenter left>
            <h2 className="card-title mb-2 text-muted">{this.lbl('vehicle.info.finance.outgoing_invoice_data')}</h2>
            <div style={{ marginLeft: 'auto' }} onClick={() => this.setState({ isOpen: !this.state.isOpen })}>
              <IsOpen />
            </div>
          </HBox>

          {this.state.isOpen && (
            <>
              {invoice && (
                <List className={styles.list}>
                  {typesArr.map(property => {
                    if (property == 'client') {
                      return (
                        invoice?.outgoingCompany?.id && (
                          <Row key={property}>
                            <Cell>{this.lbl(`vehicle.info.finance.${property}`)}</Cell>
                            {/* <Cell>{`${getPropByName(invoice?.outgoingCompany, 'name') || ''}`}</Cell> */}
                            <Cell>
                              <Link to={`/companies/${vehicle?.invoice_outgoing_company_id ?? ''}`}>
                                {outgoingCompanyLabel}
                              </Link>
                            </Cell>
                          </Row>
                        )
                      );
                    }

                    if (property == 'seller') {
                      return (
                        vehicle?.user_seller_id && (
                          <Row key={property}>
                            <WithUser user_id={vehicle?.user_seller_id}>
                              <Cell>{this.lbl(`vehicle.info.finance.${property}`)}</Cell>
                              <Cell>{`${this.props.userSeller?.name ?? ''} ${this.props.userSeller?.surname ?? ''}`}</Cell>
                            </WithUser>
                          </Row>
                        )
                      );
                    }

                    if (property == 'total_amount') {
                      return (
                        invoice?.id && (
                          <Row key={property}>
                            <Cell>{this.lbl(`vehicle.info.finance.${property}`)}</Cell>
                            <Cell>{invoice?.financialTotalAmount}</Cell>
                          </Row>
                        )
                      );
                    }

                    if (property == 'extra_total_amount') {
                      return (
                        this.extraTotalEmount && (
                          <Row key={property}>
                            <Cell>{this.lbl(`vehicle.info.finance.${property}`)}</Cell>
                            <Cell>{this.extraTotalEmount}</Cell>
                          </Row>
                        )
                      );
                    }
                    if (property == 'outgoing_invoice_generated_date') {
                      return (
                        this.props.vehicle[property] && (
                          <Row key={property}>
                            <Cell>{this.lbl(`vehicle.info.finance.${property}`)}</Cell>
                            <Cell>{getDate(this.props.vehicle[property])}</Cell>
                          </Row>
                        )
                      );
                    }
                    if (property == 'outgoing_invoice_finalized_date') {
                      return (
                        this.props.vehicle[property] && (
                          <Row key={property}>
                            <Cell>{this.lbl(`vehicle.info.finance.${property}`)}</Cell>
                            <Cell>{getDate(this.props.vehicle[property])}</Cell>
                          </Row>
                        )
                      );
                    }
                    if (property == 'bpm_guarantee_sum') {
                      return (
                        this.props.vehicle[property] && (
                          <Row key={property}>
                            <Cell>{this.lbl(`vehicle.info.finance.${property}`)}</Cell>
                            <Cell>€ {vehicle?.bpm_guarantee_sum}</Cell>
                          </Row>
                        )
                      );
                    }
                    if (property == 'paymentStatus') {
                      return (
                        <Row key={property}>
                          <Cell>{this.lbl(`vehicle.info.finance.payment_status`)}</Cell>
                          <Cell>
                            <InvoiceStatus className="status-label" status={invoice?.status?.name} />
                          </Cell>
                        </Row>
                      );
                    }
                  })}
                  {vehicle?.regplate && (
                  <Row>
                    <Cell>{this.lbl(`vehicle.property.bedrijfsvoorraad`)}</Cell>
                    <Cell>
                      <a href={`https://ovi.rdw.nl/?kenteken=${vehicle?.regplate}`} target="_blank">
                        {vehicle?.orb_stock_status === '1' ? this.lbl('vehicle.details.yes') : this.lbl('vehicle.details.no')}
                      </a>
                    </Cell>
                  </Row>
                  )}
                </List>
              )}
            </>
          )}
        </Container>
      </Card>
    );
  }
}

VehicleOutgoingInvoiceCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWork(REQUEST_INVOICE, REQUEST_USER),
    invoice: selectInvoiceById(ownProps.vehicle?.outgoing_invoice),
    userSeller: selectUser(ownProps.vehicle?.user_seller_id),
    permissions: selectPermissions(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch(invoiceId, callback) {
      dispatch(fetchInvoice(invoiceId, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleOutgoingInvoiceCard = compose(withConnect, withRouter)(VehicleOutgoingInvoiceCardComp);
